import React from "react";
import PaymentMain from 'components/subscription/index'
import PaymentReturn from "components/subscription/return";
import Errors from 'components/error404';


export function PaymentRoutes() {
    return [
        {
            path: '',
            element: (<PaymentMain />),
            errorElement: <Errors />,
        },
        // {
        //     path: 'return',
        //     element: (<PaymentReturn />),
        //     errorElement: <Errors />,
        // }
    ]
}

export default PaymentRoutes;